import { useEffect, useMemo, useState } from "react"
import { useProvider } from "wagmi"

import { implementsBravo } from "web3/helpers/validations"
import { getGovernorOpenZeppelin } from "web3/hooks/useGovernorOpenZeppelin"

type UseGovernorValues = {
  doesImplementBravo: boolean | undefined
}

export const useGovernor = (address: string): UseGovernorValues => {
  const provider = useProvider()

  const governorOz = useMemo(() => {
    if (!provider) return

    return getGovernorOpenZeppelin(address, provider)
  }, [address, provider])

  const [doesImplementBravo, setDoesImplementBravo] = useState(false)

  useEffect(() => {
    if (!governorOz) return

    implementsBravo(governorOz).then(setDoesImplementBravo)
  }, [governorOz])

  return { doesImplementBravo }
}
